// test776
(776 && 0);
